import { useEffect, useState } from 'react';

import { getByKey } from 'utils';

type EsportIconsPack = typeof import('assets/esport-icons-pack')['default'];

type ClassicIconsPack = typeof import('assets/classic-icons-pack')['default'];

let esportIconsPack: EsportIconsPack | null = null;
let classicIconsPack: ClassicIconsPack | null = null;

interface Input {
    gameId: string;
}

interface Output {
    glyph: any;
}

const loadEsportIconsPack = async (callback: VoidFn) => {
    const svgPack = await import(
        /* webpackChunkName: "esport-icons" */ 'assets/esport-icons-pack'
    );
    esportIconsPack = svgPack.default;
    callback();
};

const loadClassicIconsPack = async (callback: VoidFn) => {
    const svgPack = await import(
        /* webpackChunkName: "classic-icons" */ 'assets/classic-icons-pack'
    );
    classicIconsPack = svgPack.default;
    callback();
};

const useGameLogo = ({ gameId }: Input): Output => {
    const isEsport = gameId.includes('esport');
    const [, forceUpdate] = useState<number>(0);

    useEffect(() => {
        if (
            getByKey(esportIconsPack, gameId) ||
            getByKey(classicIconsPack, gameId)
        )
            return;

        const callback = () => forceUpdate(s => s + 1);

        if (isEsport) {
            loadEsportIconsPack(callback);
        } else {
            loadClassicIconsPack(callback);
        }
    }, [gameId, isEsport]);

    const defaultIcon = isEsport
        ? esportIconsPack?.default
        : classicIconsPack?.default;

    return {
        glyph:
            getByKey(esportIconsPack, gameId) ||
            getByKey(classicIconsPack, gameId) ||
            defaultIcon,
    };
};

export default useGameLogo;
